import * as Sentry from "@sentry/react";
import { MbCard } from "./MbCard";
import { Button } from "./ui/button";
import { AlertTriangle } from "lucide-react";

export function ErrorBoundary({ children }: { children: React.ReactNode }) {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <div className="min-h-screen bg-background flex items-center justify-center p-4">
          <MbCard className="max-w-md p-8 text-center">
            <AlertTriangle className="w-16 h-16 mx-auto mb-4 text-destructive" />
            <h2 className="text-2xl font-bold mb-2">કંઈક ખોટું થયું</h2>
            <p className="text-muted-foreground mb-4">
              {error instanceof Error ? error.message : "એક અણધારી ભૂલ થઈ"}
            </p>
            <Button onClick={resetError} variant="default">
              ફરી પ્રયાસ કરો
            </Button>
          </MbCard>
        </div>
      )}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
